import {v4} from "uuid";

export class UuidGenerator {
    static regNavn = "uuidGenerator";

    constructor() {
    }

    //offentlige metoder

    generer() {
        return v4();
    }

}